import {Component, Input} from '@angular/core';
import {Host, MinAmountCheckResult} from "../../../../common";

@Component({
  selector: 'min-amount-warning',
  standalone: false,
  template: `
      <div class="mt-3 alert alert-danger" role="alert" *ngIf="!result.valid">
        <span i18n>The minimum order amount of {{ result.min|currency:host }} is not reached yet: </span>
        <span i18n>{{ result.missing|currency:host }} are missing.</span>
      </div>
      <div class="mt-3 alert alert-warning" role="alert" *ngIf="result.fee && result.valid">
        <span i18n>Delivery fee: {{ result.fee|currency:host }}</span>
      </div>
  `
})

export class MinAmountWarning {
  @Input() result: MinAmountCheckResult;
  @Input() host: Host;
}
